import type { TypedDocumentNode } from '@apollo/client';
import { gql } from '@apollo/client';
import { FormattedMessage } from 'react-intl';

import { Horizontal } from '#src/atoms/layout/flex/index.tsx';
import { LabelS } from '#src/atoms/typography/index.tsx';
import { Avatar } from '#src/components/user/Avatar/index.tsx';

import type { CollectionOwner_publicUserInfoInterface } from './__generated__/index.graphql.ts';

type Props = {
  user: CollectionOwner_publicUserInfoInterface;
};
export const CollectionOwner = ({ user }: Props) => {
  return (
    <Horizontal center gap={0.5}>
      <Avatar user={user} rounded size={3} />
      <LabelS>
        <FormattedMessage
          id="Collection.Header.collectionOwner"
          defaultMessage="{nickname}'s Collection"
          values={{ nickname: user.nickname }}
        />
      </LabelS>
    </Horizontal>
  );
};

CollectionOwner.fragments = {
  publicUserInfoInterface: gql`
    fragment CollectionOwner_publicUserInfoInterface on PublicUserInfoInterface {
      slug
      ...Avatar_publicUserInfoInterface
    }
    ${Avatar.fragments.publicUserInfoInterface}
  ` as TypedDocumentNode<CollectionOwner_publicUserInfoInterface>,
};
